<script lang="ts" setup>
import { ref, computed, watch } from "vue";
import AdvancedBarChart from "./AdvancedBarChart.vue";
import { TooltipItem } from "chart.js";

const props = defineProps({
  sourceData: {
    type: Object,
    required: true,
  },
  width: {
    type: Number,
    default: 100,
  },
  height: {
    type: Number,
    default: 150,
  },
  chartName: String,
});

const chart = ref({
  labels: null as string[] | null,
  datasets: null as { backgroundColor: string; data: number[] }[] | null,
  backgroundColors: null as string[] | null,
});
const options = ref({
  responsive: true,
  maintainAspectRatio: true,
  animation: {
    duration: 2000,
  },
  scales: {
    y: {
      type: "linear",
      position: "left",
      ticks: {
        stepSize: 1,
        callback: function (value) {
          if (Number.isInteger(value)) {
            return value;
          }
          return null;
        }
      },
      title: {
        display: true,
        text: "Aantal",
        font: { size: 16 }
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        title: function (): string | null | void {
          return null;
        },
        label: function (tooltipItems: TooltipItem<"bar">): string | null | void {
          return `${tooltipItems.label}: ${tooltipItems.formattedValue}`;
        },
      },
    },
  },
});

const totalHomes = ref(0);

const chartStyle = computed(() => {
  return {
    width: `${props.width}%`,
    height: `${props.height}px`,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
  };
});

watch(
  () => props.sourceData,
  () => {
    let backgroundColors: string[] = [];
    let values: number[] = [];
    let th = 0;

    Object.values(props.sourceData).forEach((data) => {
      backgroundColors.push(data.color ? data.color : "#00A2DF");
      values.push(data.val);
      th += data.val;
    });

    chart.value.backgroundColors = backgroundColors;
    chart.value.labels = Object.keys(props.sourceData);
    chart.value.datasets = [{
      backgroundColor: "#00A2DF",
      data: values,
    }];

    totalHomes.value = th;
  },
  { immediate: true, deep: true }
);

</script>

<template>
  <v-container class="vue-chart vue-chart-homes-energy-types pa-0">
    <v-row>
      <v-col cols="auto">
        <AdvancedBarChart chart-name="energy-types" :data-set="chart" :options="options" :chartStyle="chartStyle">
        </AdvancedBarChart>
      </v-col>
    </v-row>
  </v-container>
</template>
